import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Page,
  Nav,
  NavInner,
  NavBrand,
  Section,
  H1,
  H2,
  Lead,
  Body,
  Row,
  BtnPrimary,
  BtnGhost,
  FooterBar,
  GradientText,
} from "./styles";
import { b4ImageForLang } from "./b4Media";
import { useLanguage } from "../../contexts/LanguageContext";
import LanguageFlags from "../../components/LanguageFlags";
const B4_PLATFORM_URL = "https://b4.capital/";

const sectionEyebrowStyle = {
  fontSize: "0.75rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.12em",
  color: "#10b7a6",
  marginBottom: "0.85rem",
};

const CertificadoPage = () => {
  const { language } = useLanguage();
  const certSrc = b4ImageForLang(language, "cert");
  const isEn = language === "en";

  useEffect(() => {
    document.documentElement.lang = isEn ? "en" : "pt-BR";
    const meta = document.querySelector('meta[name="description"]');
    const titlePt =
      "Certificado Vert Ecotech homologada na B4, Bolsa de Ação Climática | Mercado de carbono";
    const titleEn =
      "Certificate Vert Ecotech accredited at B4, Bolsa de Ação Climática | Carbon market";
    const descPt =
      "Certificado de empresa homologada na B4, Bolsa de Ação Climática. Valide o status na plataforma oficial.";
    const descEn =
      "B4, Bolsa de Ação Climática company accreditation certificate. Validate status on the official platform.";
    document.title = isEn ? titleEn : titlePt;
    meta?.setAttribute("content", isEn ? descEn : descPt);
  }, [isEn]);

  return (
    <Page>
      <Nav>
        <NavInner>
          <NavBrand>
            <Link to="/" style={{ color: "inherit", textDecoration: "none" }}>
              ← <GradientText>Vert Ecotech · B4 Capital</GradientText>
            </Link>
          </NavBrand>
          <LanguageFlags variant="dark" />
        </NavInner>
      </Nav>

      <Section style={{ paddingTop: "3rem" }}>
        <H1 style={{ marginBottom: "1rem" }}>
          {isEn ? (
            <>
              Company certificate accredited at{" "}
              <GradientText>B4</GradientText>
            </>
          ) : (
            <>
              Certificado de Empresa Homologada na{" "}
              <GradientText>B4</GradientText>
            </>
          )}
        </H1>
        <Lead style={{ textAlign: "center", maxWidth: 600, margin: "0 auto 1.5rem" }}>
          {isEn
            ? "Official B4, Bolsa de Ação Climática accreditation document for the selected language. Download the PNG below."
            : "Documento oficial de homologação B4, Bolsa de Ação Climática no idioma selecionado. Baixe o PNG abaixo."}
        </Lead>

        <div style={{ maxWidth: 520, margin: "0 auto 2.5rem" }}>
          <p style={{ ...sectionEyebrowStyle, textAlign: "center" }}>
            {isEn ? "Certificate — preview" : "Certificado — visualização"}
          </p>
        <img
          key={`cert-main-${language}`}
          src={certSrc}
            alt={
              isEn
                ? "B4 homologated company certificate"
                : "Certificado empresa homologada na B4"
            }
            style={{
              width: "100%",
              height: "auto",
              borderRadius: 14,
              display: "block",
              border: "1px solid rgba(78, 216, 255, 0.2)",
            }}
          />
        </div>

        <Body style={{ textAlign: "center", maxWidth: 560, margin: "0 auto 1.75rem" }}>
          {isEn
            ? "Public validation of status can be done on the B4 platform, ensuring authenticity and transparency."
            : "A validação pública do status pode ser feita diretamente na plataforma B4, garantindo autenticidade e transparência."}
        </Body>

        <div style={{ maxWidth: 520, margin: "0 auto 2.5rem", textAlign: "center" }}>
          <p style={{ ...sectionEyebrowStyle, textAlign: "center" }}>
            {isEn ? "Download — PNG" : "Download — PNG"}
          </p>
          <Row style={{ justifyContent: "center", flexWrap: "wrap", gap: "1rem" }}>
            <BtnPrimary
              href={certSrc}
              download={
                isEn
                  ? "Certificado-Vert-B4-EN.png"
                  : "Certificado-Vert-B4-PT.png"
              }
            >
              {isEn ? "Download certificate" : "Baixar certificado"}
            </BtnPrimary>
            <BtnGhost href={B4_PLATFORM_URL} target="_blank" rel="noopener noreferrer">
              {isEn ? "Official B4 site" : "Página oficial da B4"}
            </BtnGhost>
          </Row>
        </div>

        <Section style={{ padding: "3rem 0 0", maxWidth: 720 }}>
          <H2 style={{ fontSize: "1.25rem" }}>
            {isEn ? "About accreditation" : "Sobre a homologação"}
          </H2>
          <Body>
            {isEn
              ? "Accreditation confirms that the company meets the operational and compliance requirements defined by B4, Bolsa de Ação Climática for activity on the platform, including audit trails and governance aligned with the carbon credit market."
              : "A homologação reconhece que a empresa cumpre os requisitos operacionais e de compliance definidos pela B4, Bolsa de Ação Climática para atuação na plataforma, incluindo trilhas de auditoria e governança alinhadas ao mercado de créditos de carbono."}
          </Body>
        </Section>
      </Section>

      <FooterBar>
        <Link to="/" style={{ color: "#10b7a6" }}>
          {isEn
            ? "Back to B4, Bolsa de Ação Climática / Vert Ecotech page"
            : "Voltar à página B4, Bolsa de Ação Climática / Vert Ecotech"}
        </Link>
      </FooterBar>
    </Page>
  );
};

export default CertificadoPage;
